module.exports = __webpack_public_path__ + "img/28.d70f7595.png";